import TransactionRow from "./TransactionRow";

const TransactionTable = ({ transactions }) => {
  return (
    <div className="border rounded-lg overflow-x-auto">
      <div className="min-w-[640px]">
        <div className="grid grid-cols-7 text-xs font-medium bg-gray-50 px-3 py-2">
          <span></span>
          <span>Date</span>
          <span className="col-span-2">Transaction</span>
          <span className="col-span-2">Ref ID</span>
          <span>Balance</span>
        </div>

        <div className="max-h-64 overflow-y-auto">
          {transactions.length === 0 ? (
            <p className="text-center text-xs py-6 text-gray-400">
              No transactions for this month
            </p>
          ) : (
            transactions.map((item) => (
              <TransactionRow key={item.id} data={item} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionTable;
